import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useGetActiveAsamsQuery } from "graphql/generated/schema-types";
import { Alert, AlertType } from "shared-components/toast";

interface SystemSelection {
  systemId: number;
  asamId: number;
}

interface SelectedSystemProps {
  automationMethodId: number;
  selectedSystem: number;
  handleSystemChanged: (selection: SystemSelection) => void;
}

export const SelectedSystem = ({
  automationMethodId,
  selectedSystem,
  handleSystemChanged,
}: SelectedSystemProps) => {
  const { data: activeASAMs } = useGetActiveAsamsQuery({
    variables: {
      where: {
        automationMethodId: { eq: automationMethodId },
      },
    },
  });

  const hasError = selectedSystem === 0;
  return (
    <FormControl variant="outlined" error={selectedSystem === 0}>
      <InputLabel id="system-label">System</InputLabel>
      <Select
        value={selectedSystem}
        label="System"
        variant="outlined"
        size="small"
        onChange={(e) => {
          const systemId = e.target.value as number;
          const selected = activeASAMs?.activeASAMs?.find(
            (a) => a?.arraySystemId === systemId
          );
          if (selected) {
            handleSystemChanged({
              systemId: selected.arraySystemId,
              asamId: selected.arraySystemAutomationMethodId,
            });
            return;
          }
          Alert({
            type: AlertType.ERROR,
            message:
              "Something went wrong with selection. Try refreshing the page. If the problem persists, please file a SoftDev ticket.",
          });
          return;
        }}
      >
        {activeASAMs?.activeASAMs?.map((item) => (
          <MenuItem value={item?.arraySystemId}>{item?.arraySystemId}</MenuItem>
        ))}
      </Select>
      {hasError ? (
        <FormHelperText>System must be selected</FormHelperText>
      ) : null}
    </FormControl>
  );
};
